<template>
  <div class="ads-horizontal">
    <google1x1 />
    <google-profile-horizontal v-if="!isMobile" />
  </div>
</template>

<script>
import GoogleProfileHorizontal from "@/components/Ads/GoogleProfileHorizontal";
import Google1x1 from "@/components/Ads/Google1x1";

export default {
  name: "AdsHorizontal",
  components: { Google1x1, GoogleProfileHorizontal },

  data() {
    return {
      windowWidth: window.innerWidth
    }
  },

  computed: {
    isMobile() {
      return this.windowWidth <= 768;
    }
  },

  created() {
    this.handleResize = () => {
      this.windowWidth = window.innerWidth;
    };
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped lang="scss">
.ads-horizontal {
  height: 90px;
  width: 100%;
  max-width: 978px;
  margin: 0 auto 25px;
  overflow: hidden;

  & > div {
    padding: 0;
  }
}

@media screen and (max-width: 1050px) {
  .ads-horizontal {
    max-width: 728px;
  }
}

@media screen and (max-width: 380px) {
  .ads-horizontal {
    display: none;
  }
}
</style>
